import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";

export function getNPDS(
  selectedPdsrId: number | undefined,
  ftlRoutes: Array<FtlRouteViewModel> | undefined
) {
  const undefindedObjects = {
    network: undefined,
    plant: undefined,
    dock: undefined,
    supplier: undefined,
  };
  if (!selectedPdsrId || !ftlRoutes) {
    return undefindedObjects;
  }

  const oneRouteWithPdsr = ftlRoutes.find((r) =>
    r.PdsrsOnThisRoute?.find((s) => s.PdsrId === selectedPdsrId)
  );

  if (!oneRouteWithPdsr) {
    return undefindedObjects;
  }

  const thePdsr = oneRouteWithPdsr.PdsrsOnThisRoute?.find(
    (p) => p.PdsrId === selectedPdsrId
  );

  if (!thePdsr) {
    return undefindedObjects;
  }

  return {
    network: thePdsr.ContainerNetwork,
    plant: thePdsr.PlantGsdb,
    dock: thePdsr.DockCode,
    supplier: thePdsr.SupplierGsdb,
  };
}
